import { useTheme } from "@emotion/react";
import { Box, ButtonBase, CircularProgress, InputBase, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import MConfirmationWithValue from "../../../../components/global/Modals/MConfirmationWithValue";
import MConfirmation from "../../../../components/global/Modals/MConfirmation";
import ButtonGroup from "../../../../components/theme/buttons/ButtonGroup";
import Shbutton from "../../../../components/theme/buttons/Shbutton";
import ShLabel from "../../../../components/theme/label/ShLabel";
import Subheading from "../../../../components/theme/text/Subheading";
import Text from "../../../../components/theme/text/Text";
import { useGetCarrierBarcodeMutationMutation, useGetCarriersSelectEcheckQuery, useGetCarriersSelectQuery } from "../../../../newapi/carrier/carrierSlice";
import { useFinalizeOrderMutation, useFindIndividualOrderMutation, useFindPickingJobMutation, useFindProductByIdInPickingJobMutation, useFindProductInPickingJobMutation, useGetDeliveryOptionsQuery, usePauseOrderMutation, useSetJokerMutation, useStartFindOrdersMutationMutation } from "../../../../newapi/global/echeckSlice";
import { useGetShippersSelectWithProfilesQuery } from "../../../../newapi/shipper/shipperSlice";
import { tokens } from "../../../../theme";
import { showToastMessage, showToastMessageRequestError } from "../../../../utils/toasts";
import { ReactComponent as BarcodeSvg } from "../../../../styles/svg/barcode.svg";
import EcheckView from "./views/EcheckView";
// import SelectedOrderView from "./views/SelectedOrderView";
import MSelectLabel from "../../../../components/global/Modals/MSelectLabel";
import MPauseOrder from "../../../../components/global/Modals/MPauseOrder";
import SHQuickAction from "../../../../components/theme/Modal/SHQuickAction";
import ShCopyButton from "../../../../components/theme/ShCopy";
import ShPayloadToggle from "../../../../components/theme/ShPayloadToggle";
import Heading from "../../../../components/theme/text/Heading";
import { useGetOrderPickingSlipPDFMutation } from "../../../../newapi/order/ordersSlice";
import { useGetAvailableTimeslotsQuery, useGetAvailablePickupDatesMutation, useFindBolreplenishmentByIdQuery } from "../../../../newapi/webshop/bolreplenishmentSlice";
import { cleanQrCode, formatPrice } from "../../../../utils/helpers";
import { echeck_scan_option,  general_states, orderline_type } from "../../../../utils/staticEnums";
import PreviousOrderEchecked from "../components/views/PreviousOrderEchecked";
import SelectedOrderView from "../components/views/SelectedOrderView";
import { ProductHoverDetails } from "../orders/OrdersEcheckView2";
import MHasDocumentsModal from "../../../../components/global/Modals/MHasDocumentsModal";
import MEcheckOutboundInstruction from "../../../../components/global/Modals/MEcheckOutboundInstruction";
import { filterShipperProfilesByDeliveryCountry, findPackagingBarcodeRow, formatPickupTimeSlot, getOrderDeliveryCountry, isReadyToFinalize, mergeVirtualProductNames, purgeEmptyCarriersAndBundles, splitAutoEcheckAddons, addRemainingRowsToFirstCarrier, prefillRestartedOrder, getProductValidation, shouldConfirmProductAmount, exceedsOrderValueThreshold } from "../helper";
import { EcheckOrderListHeader } from "../components/EcheckOrderListHeader";
import { ToScanProductRow } from "../components/ToScanProductRow";
import { echeckMinimumBarcodeLength, echeckScannerDelta } from "../../../../utils/constants";
import MEcheckCheckSerialNumber from "../../../../components/global/Modals/MEcheckCheckSerialNumber";

const IndividualOrderEcheckView = (props) => {
    const { t, ready,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode); 

    const [isBundling, setIsBundling] = useState(false);
    const [newBundle,setNewBundle] = useState([]);
    const [newBundleName,setNewBundleName] = useState();
    const [carrierToAddTo,setCarrierToAddTo] = useState(null);
    const [maxCarrierAmount,setMaxCarrierAmount] = useState(null);

    const [showOptions, setShowOptions] = useState(false);
    const inputRef = useRef(null);
    const inputRefWhenOneOrderWasAlreadyScanned = useRef(null);

    const [currentOrder, setCurrentOrder] = useState(null);
    const [invoiceProducts,setInvoiceProducts] = useState(null);

    const [currentOrderWarehouseId, setCurrentOrderWarehouseId] = useState(null);
    const [toScanRows, setToScanRows] = useState(null);
    const [originalOrderlines, setOriginalOrderlines] = useState(null); // Track original orderlines with externalId for proper reduction

    const [toScanProducts, setToScanProducts] = useState(null);

    // getpicking
    const [findProductInPickingJob,{isLoading:findProductInPickingJobLoading}] = useFindProductInPickingJobMutation();

    const [findProductByIdInPickingJob, {isLoading:findProductByIdInPickingJobLoading}] = useFindProductByIdInPickingJobMutation();
    // const [findOrderInPickingJob] = useFindOrderInPickingJobMutation();
    const [findIndividualOrder] = useFindIndividualOrderMutation();
    const [pauseOrder] = usePauseOrderMutation();
    const [startFindOrders, {isLoading:startFindOrdersLoading}] = useStartFindOrdersMutationMutation();

    useEffect(() => {
        if(props.orderToFinalize !== null){
            // Check if we have pre-fetched data from container scan
            if(props.incData?.order && props.incData.viewType === "individualOrder") {
                // Use the already-fetched data instead of fetching again
                setOrderToScanData(props.incData, "");
            } else {
                // Fetch the order data as before
                if(props.orderToFinalize.state === general_states.SHIPPED){
                    handleShippedOrderClick(props.orderToFinalize.id);
                } else {
                    handlePausedOrderClick(props.orderToFinalize.id)
                }
            }
        }
    }, [props.orderToFinalize, props.incData])

    const [suggestedCarrier, setSuggestedCarrier] = useState(null);

    const [selectedShipper, setSelectedShipper] = useState('');
    const [selectedShipperProfile, setSelectedShipperProfile] = useState('');

    const [totalWeight, setTotalWeight] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);

    const [matchedProduct, setMatchedProduct] = useState(null);
    // Packed amount of a scanned packaging barcode, consumed by the matchedProduct effect
    const packagingScanAmountRef = useRef(null);
    const [incCarrier, setIncCarrier] = useState("dummy");

    const [finalizeResponse, {isLoading: finalizeLoading,isFetching:finalizeFetching}] = useFinalizeOrderMutation();

    const [setJokerResponse, {isLoading: setJokerLoading}] = useSetJokerMutation();
    const [deliveryOptions, setDeliveryOptions] = useState({});
    const [carrierForDeliveryToFetch, setCarrierForDeliveryToFetch] = useState(null);
    const [deliveryOptionsFetchData, setDeliveryOptionsFetchData] = useState(null);
    const [selectedOrder, setSelectedOrder] = useState(null);

    const [previousOrder, setPreviousOrder] = useState(null);
    const [restartedOrder, setRestartedOrder] = useState(null); // { orderId, carrier, prefilled }
    // Auto finalize is off for the restarted order only, never for another order on screen
    const isRestartedOrder = restartedOrder !== null && currentOrder !== null && restartedOrder.orderId === currentOrder.id;

    const { data: deliveryOptionsData } = useGetDeliveryOptionsQuery(deliveryOptionsFetchData, {
        skip: !deliveryOptionsFetchData
    });

    // const [carrierRows, setCarrierRows] = useState([]);
    const [open, setOpen] = useState(false);
    const [closeOpen, setCloseOpen] = useState(false);
    const [paModalOpen, paModalSetOpen] = useState(false);
    const [skipModalOpen, setSkipModalOpen] = useState(false);
    const [shownInstructionSkus, setShownInstructionSkus] = useState({});
    const [outboundInstructionModal, setOutboundInstructionModal] = useState({ open: false, sku: "", instruction: "" });
    const [productAmountModalOpen, setProductAmountModalOpen] = useState(false);
    // Order value above the relation threshold: the message modal, and the without-label choice kept while it is open
    const [orderValueModal, setOrderValueModal] = useState({ open: false, withoutLabel: null });
    // Finalize without label: the reason modal, and the choice kept while the product amount check asks for confirmation
    const [withoutLabelModalOpen, setWithoutLabelModalOpen] = useState(false);
    const [pendingWithoutLabel, setPendingWithoutLabel] = useState(null);
    // Tells the waiting bar that no label is printed for the order being finalized
    const [finalizingWithoutLabel, setFinalizingWithoutLabel] = useState(false);

    // Warn the operator when a B2B order is opened, if the setting is enabled.
    // The modal lives at the echeck root so it isn't duplicated across the
    // desktop/mobile mounts of this view (see EcheckContentWrapper/TabViewBody).
    useEffect(() => {
        if (props.displayPopupForB2bOrder && currentOrder?.isB2B) {
            props.onB2bOrderOpened?.();
        }
    }, [currentOrder?.id, props.displayPopupForB2bOrder]);

    const clearInstructionShown = (sku) => {
        if(!sku) return;
        setShownInstructionSkus(prev => {
            if(!prev[sku]) return prev;
            const next = { ...prev };
            delete next[sku];
            return next;
        });
    };
    const [labelsModal, setLabelsModal] = useState({
        open: false,
        labels: [],
        type: ''
    });

    const [hasDocumentsModel, setDocumentsModal] = useState({
        open: false,
    });

    // Message configured on the sales channel to show after an order is shipped
    const [finalizeMessageModal, setFinalizeMessageModal] = useState({
        open: false,
        message: "",
    });

    const [serialNumberModalData,setSerialNumberModalData] = useState(0);
    const [modalData, setModalData] = useState(0);
    const [closeModalData, setCloseModalData] = useState(0);
    const [paModalData, setPaModalData] = useState(0);

    const [ fetchCarrierBarcode, {data: fetchedIncCarrier,isError, isLoading: isLoadingC, refetch: refetchCarrier}] = useGetCarrierBarcodeMutationMutation();

    const [carriers, setCarriers] = useState([{
        "carrierId" : null,
        "bundle":false,
        "carrierName" : "",
        "totalProducts" : 0,
        "totalWeight" : 0,
        "deliveryOption": null,
        "dimensions": null,
        "rows": [],
    }]);




    const confirmModalOrder = (id) => {
        // setCurrentOrderId(id);
    }

    const confirmModal = {
        open: open,
        setOpen: setOpen,
        data:modalData,
        confirm: confirmModalOrder
    }

    const closeConfirmModalOrder = () => {
        props.setShowEcheck(false);
    }

    const confirmCloseModal = {
        open: closeOpen,
        setOpen: setCloseOpen,
        data:closeModalData,
        confirm: closeConfirmModalOrder
    }

    const confirmProductAmount = (amount) => {
        if (amount === 0) {
            return;
        }
        
        updateCarrierAndScanRows(parseInt(amount));
    }

    const productAmountModal = {
        open: paModalOpen,
        setOpen: paModalSetOpen,
        data:paModalData,
        confirm: confirmProductAmount
    }

    const { data: shippers } = useGetShippersSelectWithProfilesQuery({warehouseId: currentOrderWarehouseId, includeBol: true},
        {
            skip: !currentOrderWarehouseId
        }
    );

    const [goFinalize, setGoFinalize] = useState(false);
    const [timer, setTimer] = useState(null);
    const [finalizeReady, setFinalizeReady] = useState(false);
    const [showSlide, setShowSlide] = useState(false); // Controls slide visibility
    const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);
    const [selectedTimeSlotOptions, setSelectedTimeSlotOptions] = useState([]);
    // Why Bol offers no pickup times, e.g. an amount of load carriers Bol does not collect
    const [pickupTimeSlotError, setPickupTimeSlotError] = useState(null);

    // The echeck order only carries the id of its Bol replenishment, the type decides between delivery and pickup
    const {currentData: bolReplenishment, isError: bolReplenishmentError} = useFindBolreplenishmentByIdQuery(currentOrder?.bolReplenishmentId,
        {skip: !currentOrder?.bolReplenishmentId});
    // Until the replenishment is known it is unclear whether the order ships by a shipper or is picked up by Bol
    const bolReplenishmentLoading = !!currentOrder?.bolReplenishmentId && !bolReplenishment && !bolReplenishmentError;
    const isPickupReplenishment = bolReplenishment?.type === "pickup";
    // Bol collects a pickup itself, so it needs a pickup time slot instead of a shipper and shipper profile
    const shipperSelected = !bolReplenishmentLoading && (isPickupReplenishment
        ? !!selectedTimeSlot?.fromDateTime
        : !!selectedShipper && !!selectedShipperProfile);

    const {data: availableTimeslots, isLoading: availableTimeslotsLoading} = useGetAvailableTimeslotsQuery(currentOrder?.bolReplenishmentId,
        {skip: !currentOrder?.bolReplenishmentId || bolReplenishmentLoading || isPickupReplenishment});

    useEffect(() => {
        if(availableTimeslots && !availableTimeslotsLoading){
            setSelectedTimeSlotOptions(availableTimeslots.data);
            setSelectedTimeSlot(availableTimeslots.data[0]);
        }
    }, [availableTimeslots, availableTimeslotsLoading])

    const [fetchAvailablePickupDates] = useGetAvailablePickupDatesMutation();
    const carrierAmount = carriers?.length ?? 0;

    useEffect(() => {
        if (!isPickupReplenishment) return;
        if (!currentOrder?.bolReplenishmentId) return;
        if (carrierAmount <= 0) return;

        setPickupTimeSlotError(null);
        // A response for an earlier order or amount of load carriers must not overwrite the current slots
        let ignore = false;
        fetchAvailablePickupDates({
            id: currentOrder.bolReplenishmentId,
            carrierAmount,
        })
            .unwrap()
            .then((res) => {
                if (ignore) return;
                const dates = (res?.data ?? []).map(slot => ({ ...slot, name: formatPickupTimeSlot(slot) }));
                setSelectedTimeSlotOptions(dates);
                // Keep the chosen slot when Bol still offers it for the new amount of load carriers
                setSelectedTimeSlot(current => dates.find(slot => slot.fromDateTime === current?.fromDateTime && slot.untilDateTime === current?.untilDateTime) ?? dates[0] ?? null);
            })
            .catch((err) => {
                if (ignore) return;
                setSelectedTimeSlotOptions([]);
                setSelectedTimeSlot(null);
                setPickupTimeSlotError(err?.data?.message ?? t("something_went_wrong"));
            });
        return () => { ignore = true; };
    }, [isPickupReplenishment, currentOrder?.bolReplenishmentId, carrierAmount]);

    useEffect(() => {
        if(!shippers || !currentOrder) return;
        setSelectedShipper(shippers.filter(shipper => shipper.id === currentOrder?.shipper?.id)[0])
        const shipperProfileId = currentOrder?.shipperProfile?.id;
        const selectedShipperProfile = shippers.flatMap(shipper => shipper.shipperProfiles).find(profile => profile.id === shipperProfileId);
        if(selectedShipperProfile){
            setSelectedShipperProfile(selectedShipperProfile);
        } 
    }, [shippers,currentOrder])

    useEffect(() => {
        if(inputRef.current && currentOrder !== null){
            inputRef.current.focus();
        }
    },[selectedShipperProfile,inputRef,currentOrder])

    // useEffect(() => {   
    //     if(previousOrder !== null && inputRefWhenOneOrderWasAlreadyScanned.current) {
    //         inputRefWhenOneOrderWasAlreadyScanned.current.focus();
    //     }

    // }, [previousOrder,inputRefWhenOneOrderWasAlreadyScanned])

    // Handle mouse movement to cancel the timer
    useEffect(() => {
        const handleMouseMove = () => {
            if (timer) {
                clearTimeout(timer); // Cancel the timer if the mouse moves
                setShowSlide(false); // Hide the slide
                setFinalizeReady(false); // Reset finalize state
            }
        };
        window.addEventListener('mousemove', handleMouseMove);

        // Cleanup the event listener and timer on component unmount or effect cleanup
        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, [timer]);  // Re-run this effect if `timer` changes


    /// OLD: IN CASE UPDATE FOR ECHECK FAILS UNCOMMENT THIS AND COMMENT THE USEFFECT BELOW
    // // Timer logic
    // useEffect(() => {
    //     if (goFinalize) {
    //         //Temp removal of 5sec rule
    //         if(!currentOrder?.bolReplenishmentId > 0){
    //         setFinalizeReady(true);
    //         }
    //         return;

    //         // Start the timer for 5 seconds (or any duration you need)
    //         const newTimer = setTimeout(() => {
    //             setFinalizeReady(true); // Timer completed, ready to finalize
    //             setShowSlide(false); // Hide the slide once timer completes
    //         }, 5000); // 5000ms = 5 seconds

    //         setTimer(newTimer); // Store the timer ID so we can clear it later
    //         setShowSlide(true); // Show the slide while the timer is running

    //         // Cleanup the timer if finalized or component unmounts
    //         return () => {
    //             clearTimeout(newTimer);
    //         };
    //     }
    // }, [goFinalize]);  // This effect runs when `goFinalize` state changes

    useEffect(() => {
        if (goFinalize) {
            if(!currentOrder?.bolReplenishmentId > 0){
                // setFinalizeReady(true);
                // return;

                if(props.finalizeAutoOnTimer){
                    const newTimer = setTimeout(() => {
                        setFinalizeReady(true); 
                        setShowSlide(false); 
                    }, props.finalizeTimer); 

                    setTimer(newTimer); 
                    setShowSlide(true); 

                    // Cleanup the timer if finalized or component unmounts
                    return () => {
                        clearTimeout(newTimer);
                    };
                } else {
                    setFinalizeReady(true);
                }
            }
        }
    }, [goFinalize]);  

    // Finalize logic (will only run if the timer completes and mouse doesn't move)
    useEffect(() => {
        if (finalizeReady) {
            // if (selectedShipper.type === "bol") {
            //     if (carriers.every(carrier => carrier.deliveryOption !== null)) {
            //         finalize();
            //     }
            // } else {
                finalize();
           // }

            setGoFinalize(false); 
        }
    }, [finalizeReady]);  // Runs when `finalizeReady` changes

    // useEffect(() => {
    //     if (deliveryOptionsData) {
    //         setDeliveryOptions(prev => ({
    //             ...prev,
    //             [carrierForDeliveryToFetch]: deliveryOptionsData.deliveryOptions
    //         }));
    //         setCarriers(prev => {
    //             const updatedCarriers = [...prev];
    //             updatedCarriers[carrierForDeliveryToFetch].deliveryOption = deliveryOptionsData.deliveryOptions?.find(option => option.recommended) || deliveryOptionsData.deliveryOptions[0];
    //             return updatedCarriers;
    //         });
    //         setCarrierForDeliveryToFetch(null); // Reset carrierToFetch after fetching
    //     }
    // }, [deliveryOptionsData]);

    const selectShipper = (selected) => {
        var shipper = shippers?.filter(shipper => shipper.type !== 'bol' || currentOrder?.webshopcredentials?.webshop_type === 'bol')[selected];
        setSelectedShipper(shipper);
        setSelectedShipperProfile(-1);
    }

    const selectShipperProfile = (selected) => {
        const availableProfiles = filterShipperProfilesByDeliveryCountry(selectedShipper?.shipperProfiles, getOrderDeliveryCountry(currentOrder));
        var shipperProfile = availableProfiles[selected];
        setSelectedShipperProfile(shipperProfile);
    }

    const selectTimeSlot = (selected) => {
        var timeSlot = selectedTimeSlotOptions[selected];
        setSelectedTimeSlot(timeSlot);
    }

    let lastKeyTime = 0;
    let fastCount = 0;
    let totalCount = 0;
    let deltas = []; 

    const handleKeyDown = async (e) => {
        // --- Handle weird scanners that send Ctrl+J ---
        if (e.ctrlKey && e.key.toLowerCase() === 'j') {
            e.preventDefault();  // stop Chrome from opening Downloads
            e.key = 'Enter';     // fake it as Enter
            e.ctrlKey = false;   // clear ctrl
        }
        
        const now = Date.now();
        const delta = now - lastKeyTime;

        if (lastKeyTime !== 0) {
            deltas.push(delta); 
        }

        totalCount++;

        if (delta < echeckScannerDelta) {
            fastCount++;
        }

        lastKeyTime = now;

        if (e.key === 'Enter') {
            // A bare Enter (nothing typed) finalizes the order when the setting asks for it
            // and everything that auto finalize would wait for has already been scanned.
            if (e.target.value.length === 0 && props.finalizeOnEnter) {
                if (currentOrder !== null && isReadyToFinalize(toScanRows, carriers, shipperSelected, shipperSelected, props.carrierMandatory)) {
                    setGoFinalize(true);
                }
                deltas = [];
                fastCount = 0;
                totalCount = 0;
                lastKeyTime = 0;
                return;
            }

            // Accidental enter check
            if(e.target.value.length < echeckMinimumBarcodeLength) {
                e.target.value = "";

                deltas = [];
                fastCount = 0;
                totalCount = 0;
                lastKeyTime = 0;
                return;
            }
           
            //Totalcount is always one higher due to the first key not getting checked since it is the first.
            const isScanner = fastCount === (totalCount-1);

            if (!isScanner) {
                props.setHighlightColor("orange");
                
                console.log("fastCount",fastCount);
                console.log("totalCount",totalCount);

                console.log("Timing diffs:", deltas); 
                console.log("Human enter → ignore barcode flow");
                toast.warn(t("manual_input_detected_use_scanner"), {
                    position: "bottom-left",
                    autoClose: 2500,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    theme: "light",
                });

                e.target.value = "";
                deltas = [];
                fastCount = 0;
                totalCount = 0;
                lastKeyTime = 0;

                return;
            }

            const input = cleanQrCode(e.target.value);
            if(currentOrder === null) {
                setPreviousOrder(null);

                if(startFindOrdersLoading) return;

                await startFindOrders(input, props.selectedWorkSpace.id)
                .unwrap()
                .then(result => {
                    // Check if result is for an individual order
                    if (result.viewType === "individualOrder" && result.order) {
                        // Load the order in this view
                        setOrderToScanData(result, input);
                    } else {
                        // Not an individual order, show error
                        props.setHighlightColor("red");
                        props.playError?.();
                    }
                })
                .catch(error => {
                    props.setHighlightColor("red");
                    props.playError?.();
                    toast.error(error.data?.message ?? t('scan_valid_container_or_pickingslip'), {
                        position: "bottom-left",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                });
            } else {
                findLocalProduct(input);
            }

            e.target.value = "";
            deltas = [];
            fastCount = 0;
            totalCount = 0;
            lastKeyTime = 0;
        }
    }

    const handleSelectAddon = async (row) => {
        if(row.amountEchecked === row.amount){
            props.setHighlightColor("orange");
            // e.target.value = "";
            return;
        }
        if(findProductByIdInPickingJobLoading) return;
        await findProductByIdInPickingJob({
            pickingJobId:props.incData.pickingJobId,
            productId:row.product.id,
            workspaceId:props.selectedWorkSpace.id,
        })
        .unwrap()
        .then(res => {
            if(res.order){
                // setOrderToScanData(res,input);
                setSelectedProductOrderToScanData(res,row.product);
            } else {
                props.playError();
                props.setHighlightColor("red");
            }
        })
        .catch(err => {
                props.playError();
            props.setHighlightColor("red")
        })

    }

    const handlePausedOrderClick =async (id) => {
        await findIndividualOrder(id)
        .unwrap()
        .then(res => {
            if(res.order){
                setOrderToScanData(res,"");
            } else {
                props.setHighlightColor("red");
            }
        })
        .catch(err => {
            console.error(err);
            props.setHighlightColor("red")
        })
    }

    // A shipped Bol order whose shipments were cancelled goes back to the scan screen with everything in the first carrier
    const restartEcheck = async (orderId, carrier) => {
        setSelectedOrder(null);
        setPreviousOrder(null);
        setRestartedOrder({ orderId, carrier, prefilled: false });
        await handlePausedOrderClick(orderId);
    };

    const clickToProcessRow = async (product) => {

        if(findProductInPickingJobLoading) return;
        const barcode = product.barcode
            ? product.barcode.split(',')[0].trim()
            : product.barcode;

        await findProductInPickingJob({
            pickingJobId:props.incData.pickingJobId,
            barcode:barcode,
            workspaceId:props.selectedWorkSpace.id,
        })
        .unwrap()
        .then(res => {
            if(res.order){
                setOrderToScanData(res,barcode);
                // inputRef.current?.focus();
            } else {
                props.playError();
                props.setHighlightColor("red");
            }
        })
        .catch(err => {
            props.playError();
            props.setHighlightColor("red")
        })
    }

    const handleShippedOrderClick = async(id) => {
        await findIndividualOrder(id)
        .unwrap()
        .then(res => {
            if(res.order) {
                setSelectedOrder(res.order);
            } else {
                props.setHighlightColor("red");

            }
        })
        .catch(err => {
            console.error(err);
            props.setHighlightColor("red")
        })
    }

    const [chosenProductForSerial,setChosenProductForSerial] = useState(null);

    const [skuSerialMap, setSkuSerialMap] = useState({});

    const [serialNumberModalOpen,setSerialNumberModalOpen] = useState(false);
 
    const selectRow = (serialNumber) => {
        if(serialNumber != null && chosenProductForSerial != null) {
            const foundProduct =
                toScanRows.find(row => row.key === chosenProductForSerial.key) ||
                toScanRows.find(row => {
                    const rowSerial = row.serialnumbers?.[0]?.barcode;
                    return row.product.barcode === chosenProductForSerial.product.barcode && rowSerial === serialNumber;
                });

            if (foundProduct) {
                setMatchedProduct(foundProduct);
            }
        }
        setSerialNumberModalOpen(false);
    };
    const serialNumberData = {
        open: serialNumberModalOpen,
        setOpen: setSerialNumberModalOpen,
        confirm: selectRow
    }



    const setOrderToScanData = (res, value) => {
        const skuSerialMap = {}; // Map to track all serialnumbers per SKU
        const expandedLines = res.order.orderlines.flatMap(line => {
            const serials = line.serialnumbers;

            // Has serialnumbers → one entry per serialnumber
            if (Array.isArray(serials) && serials.length > 0) {
                if (!skuSerialMap[line.product.sku]) skuSerialMap[line.product.sku] = [];
                skuSerialMap[line.product.sku].push(...serials);

                return serials.map(sn => ({
                    ...line,
                    amount: 1,
                    serialnumbers: [sn]
                }));
            }

            // No serialnumbers → keep original line
            return [line];
        });
        const mergedOrderlines = Object.values(
            expandedLines.reduce((acc, line, index) => {
                const sku = line.product?.sku;
                const externalId = line.externalId;
                const hasSerial = Array.isArray(line.serialnumbers) && line.serialnumbers.length > 0;

                // Serialized entries MUST stay separate
                if (hasSerial) {
                    acc[`serial-${index}`] = line;
                    return acc;
                }

                // Create unique key combining SKU and externalId
                const groupKey = `${sku}-${line.type}`;

                // Old merging logic with externalId check
                if (!acc[groupKey]) {
                    acc[groupKey] = { ...line };
                } else {
                    acc[groupKey].amount += line.amount || 0;
                    acc[groupKey].virtualProductNames = mergeVirtualProductNames(acc[groupKey], line);
                    if (line.pickingLines) {
                        acc[groupKey].pickingLines = [...(acc[groupKey].pickingLines ?? []), ...line.pickingLines];
                    }
                }

                return acc;
            }, {})
        ).sort((a, b) => {
            // With pick locations shown the backend sends the lines in picking route order
            if (props.viewPickingLinesInOrderProcessing) return 0;
            const descA = a.product?.description?.toLowerCase() || '';
            const descB = b.product?.description?.toLowerCase() || '';
            return descA.localeCompare(descB);
        });

        setSkuSerialMap(skuSerialMap);

        // Auto-processed add-ons are placed in the first carrier automatically and
        // excluded from the rows that still need to be scanned/clicked.
        const { scanRows, autoAddonRows } = splitAutoEcheckAddons(mergedOrderlines);

        setCurrentOrder(res.order);
        setInvoiceProducts([]);
        setSuggestedCarrier(res.order?.suggestedCarrier);
        setOriginalOrderlines(expandedLines); // Store original orderlines for tracking scans with externalId
        setToScanRows(scanRows); // Display merged version (grouped by SKU only), excluding auto-processed add-ons
        setMaxCarrierAmount(
            mergedOrderlines.reduce((sum, line) => sum + (line.amount || 0), 0)
        );
        setCurrentOrderWarehouseId(res.order.warehouseId);

        let foundProduct = scanRows.find(orderline =>
            orderline.product.barcodes.some(x => {
            const barcodes = x.barcode.split(',').map(b => b.trim());
                return barcodes.includes(value);
            })
        );

        if (!foundProduct && value.length > 9) {
            const lowerValue = value.toLowerCase();

            foundProduct = scanRows.find(orderline =>
                orderline.product.barcodes.some(x => {
                    const barcodes = x.barcode.split(',').map(b => b.trim().toLowerCase());
                    return barcodes.some(b => b.includes(lowerValue));
                })
            );
        }

        if (foundProduct) {

            if(foundProduct.serialnumbers?.length > 0) {
                setChosenProductForSerial(foundProduct);
                serialNumberData.setOpen(true);
            } else {
                setMatchedProduct(foundProduct);
            }
            // setMatchedProduct(foundProduct);
        }

        if(!props.carrierMandatory){
            setCarriers([{
                carrierId: null,
                bundle: false,
                carrierName: "",
                totalProducts: 0,
                totalWeight: 0,
                deliveryOption: null,
                dimensions: null,
                rows: autoAddonRows,
            },]);
            return;
        }
        // Auto-set own carrier when suggestedCarrier type is "own", order has only 1 orderline, and carrier is mandatory
        if(res.order?.suggestedCarrier?.type === "own" && mergedOrderlines.length === 1 && mergedOrderlines[0].amount === 1){
            setCarriers([{
                carrierId: res.order?.suggestedCarrier?.id ?? -1,
                bundle: false,
                carrierName: res.order.suggestedCarrier?.name ?? t("own_carrier"),
                totalProducts: 0,
                totalWeight: 0,
                deliveryOption: null,
                dimensions: null,
                rows: autoAddonRows,
            },]);
        } else {
            setCarriers([{
                carrierId: null,
                bundle: false,
                carrierName: "",
                totalProducts: 0,
                totalWeight: 0,
                deliveryOption: null,
                dimensions: null,
                rows: autoAddonRows,
            },]);
        }

    };

    const setSelectedProductOrderToScanData = (res, product) => {
        setCurrentOrder(res.order);
        setInvoiceProducts([]);
        setSuggestedCarrier(res.order?.suggestedCarrier);
        setToScanRows(res.order.orderlines);
        setMaxCarrierAmount(res.order.orderlines.reduce((sum, line) => sum + (line.amount || 0), 0));
        setCurrentOrderWarehouseId(res.order.warehouseId);

        let foundProduct = res.order.orderlines.find(orderline =>
            orderline.product.id === product.id
        );

        if (foundProduct) {
            // console.log("found local product",foundProduct);
            if(foundProduct.serialnumbers?.length > 0) {
                setChosenProductForSerial(foundProduct);
                serialNumberData.setOpen(true);
            } else {
                setMatchedProduct(foundProduct);
            }
        } 
    
        //reset carriers
        setCarriers([{
            "carrierId" : null,
            "bundle":false,
            "carrierName" : "",
            "totalProducts" : 0,
            "totalWeight" : 0,
            "deliveryOption": null,
            "dimensions":null,
            "rows": [],
        }]);
    }


    const updateCostProduct = (selectedOption) => {
         setInvoiceProducts((e) => {
            // Handle the case where the array is initially null or undefined
            if (!e) {
                return [{
                    ...selectedOption,
                    amount: 1,
                }];
            }

            // Check if the selected product already exists in the list
            const existingProduct = e.find(product => product.id === selectedOption.id);

            if (existingProduct) {
                // If the product exists, map through the array and update its amount
                return e.map(product =>
                    product.id === selectedOption.id ? { ...product,
                        amount: product.amount + 1
                    } : product
                );
            } else {
                // If the product doesn't exist, add it to the end of the array
                return [
                    ...e, {
                        ...selectedOption,
                        amount: 1,
                    }
                ];
            }
        });
    }

    const findLocalProduct = (value,shouldTryToFindCarrier = true) => {
        // const foundProduct = toScanRows.find(orderline => {
        //     const barcodes = orderline.product.barcode.split(',').map(b => b.trim());
        //     return barcodes.includes(value);
        // });
        let foundProduct = toScanRows.find(orderline => {
            const barcodes = orderline.product.barcode.split(',').map(b => b.trim());
            return barcodes.includes(value);
        });
        
        if (!foundProduct && value.length > 9) {
            const lowerValue = value.toLowerCase();

            foundProduct = toScanRows.find(orderline => {
                const barcodes = orderline.product.barcode
                    .split(',')
                    .map(b => b.trim().toLowerCase());
                return barcodes.some(b => b.includes(lowerValue));
            });
          }

        // If multiple products found with same barcode but different types, prioritize default over add_on
        if (foundProduct) {
            const allMatches = toScanRows.filter(orderline => {
                const barcodes = orderline.product.barcode.split(',').map(b => b.trim());
                return barcodes.includes(value) || (value.length > 9 && barcodes.some(b => b.toLowerCase().includes(value.toLowerCase())));
            });

            if (allMatches.length > 1) {
                // Prefer default type over add_on when multiple matches exist
                foundProduct = allMatches.find(p => p.type !== orderline_type.ADD_ON) || foundProduct;
            }
        }

        // Packaging barcode (tray, case): scan the packed amount at once when it still fits the row
        let packagingScanAmount = null;
        if (!foundProduct) {
            const packagingMatch = findPackagingBarcodeRow(toScanRows, value);
            if (packagingMatch?.exceedsRemaining) {
                props.playError();
                props.setHighlightColor("red");
                showToastMessage("error", t("echeck_packaging_amount_exceeds_remaining", {
                    amount: packagingMatch.amount,
                    remaining: packagingMatch.remaining
                }), 5000);
                return;
            }
            if (packagingMatch) {
                foundProduct = packagingMatch.row;
                packagingScanAmount = packagingMatch.amount;
            }
        }

        if (foundProduct) {
            // console.log("found local product",foundProduct);
            if(foundProduct.serialnumbers?.length > 0) {
                setChosenProductForSerial(foundProduct);
                serialNumberData.setOpen(true);
            } else {
                packagingScanAmountRef.current = packagingScanAmount;
                setMatchedProduct(foundProduct);
            }
        } else {
            const selectedCost = props.invoiceProductsEcheck.find((dbIp) => dbIp.name === value);
            if(selectedCost){
                 updateCostProduct(selectedCost);
            } else {
                if(shouldTryToFindCarrier){
                    fetchCarrierBarcode(value).unwrap()
                    .then((result) => {
                        setIncCarrier(result);
                        // Release the selected carrier so the next scans go into the new empty carrier
                        setCarrierToAddTo(null);
                    })
                    .catch(err => {
                        props.setHighlightColor("red");
                    })
                }
            }
        }
    }

    useEffect(() => {
        if (!matchedProduct) return;

        // A packaging barcode scan carries the packed amount, set by findLocalProduct
        const packagingScanAmount = packagingScanAmountRef.current;
        packagingScanAmountRef.current = null;
    
        if (packagingScanAmount) {
            updateCarrierAndScanRows(packagingScanAmount);
        } else if (matchedProduct.amount > 16) {
            setPaModalData({
                title: "Hoeveel van dit product wil je scannen?",
                content: `${matchedProduct.amount} x ${matchedProduct.product.description}`,
                value: "",
                hasInput: true,
                inputLabel: "amount",
                inputType: "number",
                confirm: confirmProductAmount
            });
            productAmountModal.setOpen(true);
        } else {
            updateCarrierAndScanRows(1);
        }
    }, [matchedProduct]);

    // const JokerClick = () => {
    //     if(carriers[carriers.length - 1].carrierId !== null && toScanRows.length === 0){
    //         setModalData({
    //             title: "Joker een voltooide order",
    //             content: `Deze order is volledig doorlopen voor de eCheck. Weet je zeker dat je deze alsnog wilt jokeren?`,
    //             value: 0,
    //             confirm: (e) => {}
    //         });
    //         confirmModal.setOpen(true);
    //     } else {
    //         setJoker();
    //     }
    // }

    // const setJoker = async () => {
    //     const response = await setJokerResponse(currentOrder.id).unwrap();
    //     NextOrder(true);
    // }

    const updateCarrierAndScanRows = (mutation) => {
        if(props.displayPopupForOutboundInstructions){
            const instr = matchedProduct?.product?.outboundInstruction?.trim();
            const sku = matchedProduct?.product?.sku;
            if (instr && sku && !shownInstructionSkus[sku]) {
                setShownInstructionSkus(prev => ({ ...prev, [sku]: true }));
                setOutboundInstructionModal({ open: true, sku, instruction: instr });
            }
        }

        // Look up the correct externalId from originalOrderlines so carrier rows
        // are separated by externalId even though the display is merged by SKU
        const matchedOriginal = originalOrderlines?.find(orderline => {
            const barcodeMatch = orderline.product.barcode === matchedProduct.product.barcode;
            const serialMatch =
                (!orderline.serialnumbers?.[0] || !matchedProduct.serialnumbers?.[0]) ||
                orderline.serialnumbers?.[0] === matchedProduct.serialnumbers?.[0];
            const typeMatch = orderline.type === matchedProduct.type;
            return barcodeMatch && serialMatch && typeMatch;
        });
        let productForCarrier;
        if(matchedOriginal) {
            productForCarrier = { ...matchedProduct, externalId: matchedOriginal.externalId };
        } else {
            productForCarrier = matchedProduct
        }           

        setCarriers(prev => {
            let updatedCarriers = [...prev];
            if (updatedCarriers.length === 0) return updatedCarriers;

            if(carrierToAddTo){
                const { bundleIndex, carrierIndex } = carrierToAddTo;

                if (bundleIndex !== -1) {
                    // We're updating a subcarrier in a bundle
                    const updatedBundle = { ...updatedCarriers[bundleIndex] };
                    const updatedSubCarriers = [...updatedBundle.carriers];
                    const targetCarrier = { ...updatedSubCarriers[carrierIndex] };

                    const productIndex = targetCarrier.rows.findIndex(row => {
                        const rowSerial = row.serialnumbers?.[0];
                        const productSerial = productForCarrier.serialnumbers?.[0];

                        const serialMatch =
                            !rowSerial || !productSerial || rowSerial === productSerial;

                        const externalIdMatch =
                            (row.externalId && productForCarrier.externalId)
                                ? row.externalId === productForCarrier.externalId
                                : true;

                        const typeMatch = row.type === productForCarrier.type;

                        return row.product.barcode === productForCarrier.product.barcode && serialMatch && externalIdMatch && typeMatch;
                    });

                    if (productIndex !== -1) {
                        const updatedProduct = {
                            ...targetCarrier.rows[productIndex],
                            amount: targetCarrier.rows[productIndex].amount + mutation
                        };
                        targetCarrier.rows[productIndex] = updatedProduct;
                    } else {
                        const productToAdd = { ...productForCarrier, amount: mutation };
                        targetCarrier.rows.push(productToAdd);
                    }

                    updatedSubCarriers[carrierIndex] = targetCarrier;
                    updatedBundle.carriers = updatedSubCarriers;
                    updatedCarriers[bundleIndex] = updatedBundle;
                } else {
                    // Not a bundle, update flat carrier
                    const targetCarrier = { ...updatedCarriers[carrierIndex] };

                    const productIndex = targetCarrier.rows.findIndex(row => {
                        const rowSerial = row.serialnumbers?.[0];
                        const productSerial = productForCarrier.serialnumbers?.[0];

                        const serialMatch =
                            !rowSerial || !productSerial || rowSerial === productSerial;

                        const externalIdMatch =
                            (row.externalId && productForCarrier.externalId)
                                ? row.externalId === productForCarrier.externalId
                                : true;

                        const typeMatch = row.type === productForCarrier.type;

                        return row.product.barcode === productForCarrier.product.barcode && serialMatch && externalIdMatch && typeMatch;
                    });

                    if (productIndex !== -1) {
                        const updatedProduct = {
                            ...targetCarrier.rows[productIndex],
                            amount: targetCarrier.rows[productIndex].amount + mutation
                        };
                        targetCarrier.rows[productIndex] = updatedProduct;
                    } else {
                        const productToAdd = { ...productForCarrier, amount: mutation };
                        targetCarrier.rows.push(productToAdd);
                    }

                    updatedCarriers[carrierIndex] = targetCarrier;
                }
            } else{
                let targetCarrier;

                // Helper to find first carrier with carrierId === null or fallback to last
                const findTarget = (carriers) => {
                    return carriers.find(c => c.carrierId === null) || carriers[carriers.length - 1];
                };

                // Get last carrier from the list
                let lastCarrier = findTarget(updatedCarriers);

                if (lastCarrier.bundle) {
                    const subCarriers = lastCarrier.carriers;
                    targetCarrier = findTarget(subCarriers);
                } else {
                    targetCarrier = findTarget(updatedCarriers);
                }


                const productIndexInCarrier = targetCarrier.rows.findIndex(row => {
                    const rowSerial = row.serialnumbers?.[0];
                    const productSerial = productForCarrier.serialnumbers?.[0];

                    const serialMatch =
                        !rowSerial || !productSerial || rowSerial === productSerial;

                    const externalIdMatch =
                        (row.externalId && productForCarrier.externalId)
                            ? row.externalId === productForCarrier.externalId
                            : true;

                    const typeMatch = row.type === productForCarrier.type;

                    return row.product.barcode === productForCarrier.product.barcode && serialMatch && externalIdMatch && typeMatch;
                });


                if (productIndexInCarrier !== -1) {
                    const updatedProduct = {
                        ...targetCarrier.rows[productIndexInCarrier],
                        amount: targetCarrier.rows[productIndexInCarrier].amount + mutation
                    };
                    targetCarrier.rows[productIndexInCarrier] = updatedProduct;
                } else {
                    const productToAdd = { ...productForCarrier, amount: mutation };
                    targetCarrier.rows.push(productToAdd);
                }
            }

            return updatedCarriers;
        });
        // setCarriers(prev => {
        //     let updatedCarriers = [...prev];
            
        //     if (updatedCarriers.length > 0) {
        //         let lastCarrier = { ...updatedCarriers[updatedCarriers.length - 1] };
        //         const productIndexInCarrier = lastCarrier.rows.findIndex(row => row.product.barcode === matchedProduct.product.barcode);
                
        //         if (productIndexInCarrier !== -1) {
        //             const updatedProduct = { ...lastCarrier.rows[productIndexInCarrier], amount: lastCarrier.rows[productIndexInCarrier].amount + mutation };
        //             lastCarrier.rows[productIndexInCarrier] = updatedProduct;
        //         } else {
        //             let productToAdd = { ...matchedProduct, amount: mutation };
        //             lastCarrier.rows.push(productToAdd);
        //         }
                
        //         //fetchDeliveryOptions(lastCarrier);
            
        //         updatedCarriers[updatedCarriers.length - 1] = lastCarrier;
        //     }
            
        //     return updatedCarriers;
        // });

        // Reduce from original orderlines (tracking SKU + externalId + type)
        setOriginalOrderlines(prevOriginal => {
            const updatedOriginal = [...prevOriginal];
            // Use productForCarrier.externalId to reduce the same entry the carrier consumed
            const index = updatedOriginal.findIndex(orderline => {
                const barcodeMatch = orderline.product.barcode === matchedProduct.product.barcode;
                const serialMatch =
                    (!orderline.serialnumbers?.[0] || !matchedProduct.serialnumbers?.[0]) ||
                    orderline.serialnumbers?.[0] === matchedProduct.serialnumbers?.[0];
                const externalIdMatch =
                    (orderline.externalId && productForCarrier.externalId)
                        ? orderline.externalId === productForCarrier.externalId
                        : true;
                const typeMatch = orderline.type === matchedProduct.type;

                return barcodeMatch && serialMatch && externalIdMatch && typeMatch;
            });

            if (index !== -1) {
                const newAmount = updatedOriginal[index].amount - mutation;
                if (newAmount > 0) {
                    updatedOriginal[index] = { ...updatedOriginal[index], amount: newAmount };
                } else {
                    updatedOriginal.splice(index, 1);
                }
            }

            return updatedOriginal;
        });

        // Reduce from toScanRows independently (must match on type as well)
        setToScanRows(prevToScanRows => {
            const index = prevToScanRows.findIndex(orderline => {
                const barcodeMatch = orderline.product.barcode === matchedProduct.product.barcode;

                const externalIdMatch =
                    (orderline.externalId && matchedProduct.externalId)
                        ? orderline.externalId === matchedProduct.externalId
                        : true;

                const typeMatch = orderline.type === matchedProduct.type;

                return barcodeMatch && externalIdMatch && typeMatch;
            });

            if (index === -1) return prevToScanRows;

            const updatedRows = [...prevToScanRows];
            const newAmount = updatedRows[index].amount - mutation;

            if (newAmount > 0) {
                updatedRows[index] = { ...updatedRows[index], amount: newAmount };
            } else {
                updatedRows.splice(index, 1);
            }

            return updatedRows;
        });

        // Example usage: remove serialnumber for a matched product
        setSkuSerialMap(prevMap => {
            const sku = matchedProduct.product.sku;
            const serialToRemove = matchedProduct.serialnumbers?.[0];

            if (!sku || !serialToRemove || !prevMap[sku]) return prevMap; // nothing to remove

            // Filter out the serialnumber
            const updatedSerials = prevMap[sku].filter(sn => sn !== serialToRemove);

            // Create a new map
            const newMap = { ...prevMap };

            if (updatedSerials.length > 0) {
                newMap[sku] = updatedSerials; // update array
            } else {
                delete newMap[sku]; // remove SKU entirely if no serials left
            }

            return newMap;
        });

        props.playSuccess();

        props.setHighlightColor('green');
        setMatchedProduct(null);
    }


    const fetchDeliveryOptions = async (carrier) => {
        if(carriers?.length === 0) return;
        if (selectedShipper?.type === "bol" && carrier.rows.length > 0) {
            const requestBody = {
                "shipperId": selectedShipper.id,
                "items": {
                    "orderItems": carrier.rows.map(row => ({
                        "orderItemId": row.externalId,
                        "quantity": row.amount
                    }))
                }
            };

            
            //get index of carrier in carriers
            const carrierIndex = carriers.length === 1 ? 0 : carriers.findIndex(c => c.carrierId === carrier.carrierId);

            setCarrierForDeliveryToFetch(carrierIndex);
            setDeliveryOptionsFetchData(requestBody);
        }
    };

    useEffect(() => {
        if(incCarrier === "dummy") return;
        if (incCarrier) {
            setCarriers(prevCarriers => {
                const updatedCarriers = [...prevCarriers];
                if (updatedCarriers.length === 0) return updatedCarriers;

                // Helper function to find first carrier without carrierId in an array or fallback to last carrier
                const findTargetCarrier = (carriers) => {
                    const withoutId = carriers.find(c => c.carrierId === null);
                    return withoutId || carriers[carriers.length - 1];
                };

                // Get the last carrier
                let lastCarrier = findTargetCarrier(updatedCarriers);

                if (lastCarrier.bundle) {
                    const updatedSubCarriers = [...lastCarrier.carriers];

                    let targetSubCarrier = findTargetCarrier(updatedSubCarriers);
                    const targetIndex = updatedSubCarriers.findIndex(c => c === targetSubCarrier);

                    targetSubCarrier = { ...targetSubCarrier };

                    if (targetSubCarrier.carrierId === null) {
                        targetSubCarrier.carrierId = incCarrier.id;
                        targetSubCarrier.carrierName = incCarrier.name;
                        targetSubCarrier.type = incCarrier.type;
                        targetSubCarrier.dimensions = {
                            width: incCarrier.width,
                            height: incCarrier.height,
                            length: incCarrier.length,
                            weight: incCarrier.weight,
                            isFlexible: incCarrier.isFlexible,
                            type:incCarrier.type,
                        }
                    }

                    updatedSubCarriers[targetIndex] = targetSubCarrier;

                    lastCarrier = {
                        ...lastCarrier,
                        carriers: updatedSubCarriers
                    };

                    // Replace the bundle in the main list
                    updatedCarriers[updatedCarriers.length - 1] = lastCarrier;

                    if (targetSubCarrier.rows && targetSubCarrier.rows.length > 0 && toScanRows.length !== 0) {
                        updatedCarriers.push({
                            carrierId: null,
                            bundle:false,
                            carrierName: "",
                            totalProducts: 0,
                            totalWeight: 0,
                            deliveryOption: null,
                            dimensions: null,
                            rows: [],
                        });
                    }

                } else {
                    const targetCarrier = findTargetCarrier(updatedCarriers);

                    const targetIndex = updatedCarriers.findIndex(c => c === targetCarrier || c.carrierId === targetCarrier.carrierId);
                    const clonedTarget = { ...targetCarrier };

                    if (clonedTarget.carrierId === null) {
                        clonedTarget.carrierId = incCarrier.id;
                        clonedTarget.carrierName = incCarrier.name;
                        clonedTarget.type = incCarrier.type;
                        clonedTarget.dimensions = {
                            width: incCarrier.width,
                            height: incCarrier.height,
                            length: incCarrier.length,
                            weight: incCarrier.weight,
                            isFlexible: incCarrier.isFlexible,
                            type:incCarrier.type,
                        }
                    }

                    updatedCarriers[targetIndex] = clonedTarget;

                    // Add new empty carrier if rows exist and toScanRows not empty
                    if (clonedTarget.rows && clonedTarget.rows.length > 0 && toScanRows.length !== 0) {
                        updatedCarriers.push({
                            carrierId: null,
                            bundle: false,
                            carrierName: "",
                            totalProducts: 0,
                            totalWeight: 0,
                            deliveryOption: null,
                            dimensions: null,
                            rows: [],
                        });
                    }
                }
                
                if(props.carrierMandatory){
                    if(toScanRows.length === 0 && shipperSelected && props.autoFinalize && !isRestartedOrder) {
                        const hasUnassignedCarrier = updatedCarriers.some(carrier => {
                            if (carrier.bundle) {
                                return carrier.carriers.some(sub => sub.carrierId === null);
                            }
                            return carrier.carrierId === null;
                        });
                        if(!hasUnassignedCarrier) {
                            setGoFinalize(true);
                        }
                    }
                }

                return updatedCarriers;
            });
        } else {
            props.setHighlightColor('red');
            toast.error(`Onjuiste scan`, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
        setIncCarrier("dummy");
    }, [incCarrier]);

    useEffect(() => {
        // A restarted order is fully pre-scanned, so it only finalizes manually
        if(toScanRows?.length === 0 && shipperSelected && props.autoFinalize && !isRestartedOrder){
            if(props.carrierMandatory){
                const hasUnassignedCarrier = carriers.some(carrier => {
                    if (carrier.bundle) {
                        return carrier.carriers.some(sub => sub.carrierId === null);
                    }
                    return carrier.carrierId === null && carrier.rows.length > 0;
                });
                if(hasUnassignedCarrier) return;
            }
            setGoFinalize(true);
        }
    }, [carriers,toScanRows, shipperSelected,props.autoFinalize,props.carrierMandatory,isRestartedOrder]);
    
    const [shippingErrors,setShippingErrors] = useState([]);
    const [shippingPayload, setShippingPayload] = useState(null);

    // A utility function to compute updated carriers with totalWeight and totalProducts
    const computeUpdatedCarriers = (prevCarriers) => {
        return prevCarriers.map(carrier => {

            if (carrier.bundle && Array.isArray(carrier.carriers)) {
                let totalWeight = 0;
                let totalAmount = 0;

                const updatedSubCarriers = carrier.carriers.map(subCarrier => {
                    let subWeight = 0;
                    let subAmount = 0;

                    subCarrier.rows.forEach(productRow => {
                        subWeight += (productRow.amount * productRow.product.weight);
                        subAmount += productRow.amount;
                    });

                    totalWeight += subWeight;
                    totalAmount += subAmount;

                    return {
                        ...subCarrier,
                        totalWeight: subWeight,
                        totalProducts: subAmount
                    };
                });

                return {
                    ...carrier,
                    carriers: updatedSubCarriers,
                    totalWeight,
                    totalProducts: totalAmount
                };
            }

            let newTotalWeight = 0;
            let newTotalAmount = 0;

            carrier.rows.forEach(productRow => {
                newTotalWeight += (productRow.amount * productRow.product.weight);
                newTotalAmount += productRow.amount;
            });

            return {
                ...carrier,
                totalWeight: newTotalWeight,
                totalProducts: newTotalAmount
            };
        });
    };

    // Once the restarted order's scan data is loaded, put all its products in the first carrier (runs once per restart)
    useEffect(() => {
        if (!restartedOrder || restartedOrder.prefilled || currentOrder?.id !== restartedOrder.orderId || !toScanRows) return;
        const prefilled = prefillRestartedOrder(carriers, toScanRows, originalOrderlines);
        setCarriers(computeUpdatedCarriers(prefilled.carriers));
        setToScanRows(prefilled.toScanRows);
        setOriginalOrderlines(prefilled.originalOrderlines);
        setSkuSerialMap({});
        if (restartedOrder.carrier) setIncCarrier(restartedOrder.carrier);
        setRestartedOrder(prev => ({ ...prev, prefilled: true }));
    }, [restartedOrder, currentOrder, toScanRows]);

    // Closing the order value message continues finalizing with the kept without-label choice
    const acknowledgeOrderValue = () => {
        if (!orderValueModal.open) return;
        const { withoutLabel } = orderValueModal;
        setOrderValueModal({ open: false, withoutLabel: null });
        finalize(true, withoutLabel, true);
    };
    // withoutLabel ({ skipReason }) ships the order without printing its label
    const finalize = async (productAmountConfirmed = false, withoutLabel = null, orderValueConfirmed = false) => {
        // Without label and without a mandatory carrier scan, every product that was not scanned goes in the first carrier
        const carriersToSend = withoutLabel && !props.carrierMandatory
            ? computeUpdatedCarriers(addRemainingRowsToFirstCarrier(carriers, toScanRows, originalOrderlines))
            : carriers;
        let locCarriers=purgeEmptyCarriersAndBundles(carriersToSend);
        if(props.carrierMandatory){
            
            const hasUnassignedCarrier = locCarriers.some(carrier => {
                if (carrier.bundle) {
                    return carrier.carriers.some(sub => sub.carrierId === null);
                }
                return carrier.carrierId === null;
            });

            if (hasUnassignedCarrier) {
                setTimer(null);
                setFinalizeReady(false);
                setShowSlide(false);
                setGoFinalize(false); 
                showToastMessage("warning", "Er is geen drager gekozen. Selecteer of scan een drager om af te ronden.");
                return;
            }
        }
        // A single-line order with more than one product asks the operator to confirm
        // the amount first. Confirming calls finalize again with the flag set.
        if (!props.skipProductAmountCheck && !productAmountConfirmed && shouldConfirmProductAmount(currentOrder, props.confirmProductAmount)) {
            setTimer(null);
            setFinalizeReady(false);
            setShowSlide(false);
            setGoFinalize(false);
            setPendingWithoutLabel(withoutLabel);
            setProductAmountModalOpen(true);
            return;
        }
        // An order above the order value threshold of its relation shows a message first.
        // Closing it calls finalize again with both flags set.
        if (!orderValueConfirmed && exceedsOrderValueThreshold(currentOrder)) {
            setTimer(null);
            setFinalizeReady(false);
            setShowSlide(false);
            setGoFinalize(false);
            setOrderValueModal({ open: true, withoutLabel });
            return;
        }
        try {
            const { shipments, ...orderWithoutShipments } = currentOrder;
            const order = orderWithoutShipments;

            setShippingErrors([]);
            setShippingPayload(null);
            setFinalizingWithoutLabel(!!withoutLabel);
            const response = await finalizeResponse({
                "order": order,
                "carriers": locCarriers,
                "shipper": isPickupReplenishment ? null : selectedShipper.id,
                "shipperProfile": isPickupReplenishment ? null : selectedShipperProfile.id,
                "workspace": props.selectedWorkSpace.id,
                "selectedTimeSlot": isPickupReplenishment ? "" : selectedTimeSlot ?? "",
                "pickupTimeSlot": isPickupReplenishment && selectedTimeSlot ? { fromDateTime: selectedTimeSlot.fromDateTime, untilDateTime: selectedTimeSlot.untilDateTime } : null,
                "invoiceProducts":invoiceProducts ?? [],
                ...(withoutLabel ? { "finalizeWithoutLabel": true, "skipReason": withoutLabel.skipReason } : {}),
            }).unwrap();

            if(response.success){
                if(response.openFiles){
                   if (response.labelContent?.length > 1) {
                        // If multiple labels, open modal with buttons
                        setLabelsModal({
                            open: true,
                            labels: response.labelContent,
                            type: response.labelType
                        });
                    } else if (response.labelContent?.length === 1) {
                        const content = response.labelContent[0];
                        let url = "";
                        if(response.labelType === 'pdf'){
                            const decodedData = atob(content);
                            const arrayBuffer = new ArrayBuffer(decodedData.length);
                            const uint8Array = new Uint8Array(arrayBuffer);
                            for (let i = 0; i < decodedData.length; i++) {
                                uint8Array[i] = decodedData.charCodeAt(i);
                            }
                            const blob = new Blob([uint8Array], { type: 'application/pdf' });
                            url = URL.createObjectURL(blob);
                        } else if(response.labelType === 'link'){
                            url = content;
                        }
                        const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
                        if (newWindow) {
                            setTimeout(() => {
                                window.URL.revokeObjectURL(url);
                            }, 500);
                        } else {
                            window.URL.revokeObjectURL(url);
                        }
                    }
                }

                if(response.hasDocuments) {
                    setDocumentsModal({
                        open:true,
                    });
                }


                setPreviousOrder({
                    "totalAmount": totalAmount,
                    "order": order,
                    "carriers": carriersToSend,
                    "shipper": selectedShipper,
                    "shipperProfile": selectedShipperProfile,
                    "workspace": props.selectedWorkSpace.id,
                    "carrierMandatory": props.carrierMandatory,
                    "invoiceProducts":invoiceProducts ?? [],
                    "shipmentIds": response.shipmentIds,
                    "hasPickingslip":response.hasPickingslip,
                })

                if(response.echeckFinalizeMessage) {
                    // Hold the reset until the sales-channel message is acknowledged; the
                    // modal's close/confirm calls resetScreen so it must be clicked away
                    // before the screen resets for the next order.
                    setFinalizeMessageModal({
                        open: true,
                        message: response.echeckFinalizeMessage,
                    });
                } else {
                    await resetScreen();
                }

            } else {
                showToastMessage("error", response.message);
            }
        } catch (error) {
            setShippingErrors(error.data?.errors);
            setShippingPayload(error?.data?.payload ?? null);
        
            showToastMessage("error", error.data?.error);
        }
    }

    const resetScreen = async () => {
        setTimer(null);
        setFinalizeReady(false);
        setShowSlide(false);
        setGoFinalize(false); 
        setCurrentOrder(null);
        setCurrentOrder(null);
        setSuggestedCarrier(null);
        setToScanRows(null);
        setOriginalOrderlines(null);
        setCurrentOrderWarehouseId(null);
        setMatchedProduct(null);
        setSelectedOrder(null);
        setChosenProductForSerial(null);
        setSkuSerialMap({});
        setRestartedOrder(null);

        setCarriers([{
            carrierId: null,
            bundle: false,
            carrierName: "",
            totalProducts: 0,
            totalWeight: 0,
            deliveryOption: null,
            dimensions: null,
            rows: [],
        }]);

        setMaxCarrierAmount(null);
        setIsBundling(false);
        setNewBundle([]);
        setNewBundleName();
        setCarrierToAddTo(null);
        setShownInstructionSkus({});
        setOutboundInstructionModal({ open: false, sku: "", instruction: "" });
    }

    const selectLabel = (carrierIndex, index) => {
        setCarriers(prev => {
            const updatedCarriers = prev.map((carrier, idx) => 
                idx === carrierIndex ? { ...carrier, deliveryOption: deliveryOptions[carrierIndex][index] } : carrier
            );
            return updatedCarriers;
        });
    };

    // const [getOrderPickingSlipPDF, {isLoading: isFetchingPdf}] = useGetOrderPickingSlipPDFMutation();

    // const printPickingSlip = async () => {
    //     try {
    //         if (isFetchingPdf || !currentOrder) return;
    //         const response = await getOrderPickingSlipPDF({orderId: currentOrder.id}).unwrap();
    //         const newWindow = window.open(response.data, '_blank', 'noopener,noreferrer');
    //         if (newWindow) {
    //             setTimeout(() => {
    //                 window.URL.revokeObjectURL(response.data);
    //             }, 500);
    //         } else {
    //             window.URL.revokeObjectURL(response.data);
    //         }
    //     } catch (err) {
    //         showToastMessageRequestError(t('fetch_failed'), t, err)
    //     }
    // };

    const FinalizeClick = (withoutLabel = null) => {
        if(!shipperSelected) return;
        // Finalizing without label does not wait on scans unless the carrier scan is mandatory
        if(toScanRows.length === 0 || (withoutLabel && !props.carrierMandatory)){
            // if(selectedShipper.type === "bol"){
            //     if(carriers.every(carrier => carrier.deliveryOption !== null)){

            //         finalize();
            //     }
            // } else {

                finalize(false, withoutLabel);
            //}
        } else {
            setModalData({
                title: "Afronden niet mogelijk",
                content: `Je kunt deze order nog niet afronden omdat nog niet alle producten zijn gescant`,
                value: 0,
                confirm: (e) => {}
            });
            confirmModal.setOpen(true);
        }
    }

    const handleSkipOrder = (data) => {
        pauseOrder({
            id:currentOrder.id,
            skipReason:data.skipReason,
            followUpByCustomer:data.followUpByCustomer,
        })
        .unwrap()
        .then(res => {
            if(res['success']) {
                resetScreen();
            }
        }).catch(err => {
            toast.error(`Skippen ging mis`, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        })
    }

    const [skipModalData, setSkipModalData] = useState({
        title: "Weet je zeker dat je deze wilt pauzeren?",
        content: `${currentOrder?.barcode}`,
        value: "",
        hasInput: true,
        inputLabel: "reason_to_skip",
        inputType: "text",
        confirm: handleSkipOrder
    });

    useEffect(() => {
        setSkipModalData((old) => ({
            ...old,
            content: `${currentOrder?.barcode}`,
        }));
    }, [currentOrder])

    const setValueForSkipReason = (reasonToSkip) => {
        setSkipModalData((old) => ({
            ...old,
            value: reasonToSkip,
        }));
    }

    const skipOrderModal = {
        open: skipModalOpen,
        setOpen: setSkipModalOpen,
        data:skipModalData,
        confirm: handleSkipOrder
    }

    useEffect(() => {;
        const updatedCarriers = computeUpdatedCarriers(carriers);
        
        // Check if the new calculated values differ from the current carriers
        if (JSON.stringify(updatedCarriers) !== JSON.stringify(carriers)) {
            setCarriers(updatedCarriers);
        }

        const overallTotalWeight = updatedCarriers.reduce((acc, curr) => acc + curr.totalWeight, 0);
        const overallTotalAmount = updatedCarriers.reduce((acc, curr) => acc + curr.totalProducts, 0);

        setTotalWeight(overallTotalWeight);
        setTotalAmount(overallTotalAmount);

    }, [carriers]);


    const [filterBySelectedWorkSpace, setFilterBySelectedWorkSpace] = useState(true);
    const toggleFilterBySelectedWorkSpace = (event, newValue) => {
        // Ensure the newValue is boolean (true or false)
        if (newValue !== null) {
            setFilterBySelectedWorkSpace(newValue); // Directly set the newValue (boolean)
        }
    };

    const { data: carriersSelect } = useGetCarriersSelectEcheckQuery();
    const selectManualCarrier = (selected) => {
        var carrier = carriersSelect[selected];
        setIncCarrier(carrier);
        setCarrierToAddTo(null);
    }
    const OwnCarrierClick = () => {
        var carrier = {id: -1,
        name: t("own_carrier")};
        setIncCarrier(carrier);
        setCarrierToAddTo(null);
    }

    const [shipmentHighlightColor, setShipmentHighlightColor] = useState('none');
    const [highlightColor, setHighlightColor] = useState('none');

    useEffect(() => {
        if (highlightColor !== 'none') {
            setTimeout(() => setHighlightColor('none'), 500); // Duration to stay colored
        }
    }, [highlightColor]);

    useEffect(() => {
        if (shipmentHighlightColor !== 'none') {
            setTimeout(() => setShipmentHighlightColor('none'), 500); // Duration to stay colored
        }
    }, [shipmentHighlightColor]);

    // useEffect(() => {
    //     const restoreFocus = (e) => {
    //         // Let the UI do its thing…
    //         setTimeout(() => {
    //             inputRef.current?.focus();
    //         }, 0);
    //     };

    //     document.addEventListener("mousedown", restoreFocus);

    //     return () => {
    //         document.removeEventListener("mousedown", restoreFocus);
    //     };
    // }, []);
    // useEffect(() => {
    //     const restoreFocus = (e) => {
    //         // If the user clicks inside an input, do NOT steal focus
    //         const isInput =
    //             e.target instanceof HTMLInputElement ||
    //             e.target instanceof HTMLTextAreaElement ||
    //             e.target.isContentEditable;

    //         if (!isInput) {
    //             setTimeout(() => {
    //                 inputRef.current?.focus();
    //             }, 0);
    //         }
    //     };

    //     document.addEventListener("mousedown", restoreFocus);

    //     return () => {
    //         document.removeEventListener("mousedown", restoreFocus);
    //     };
    // }, []);

    useEffect(() => {
        if(!open) {
            if(previousOrder !== null && inputRefWhenOneOrderWasAlreadyScanned.current) {
                //problem is with this one
                inputRefWhenOneOrderWasAlreadyScanned.current.focus();
            } else {
                inputRef.current?.focus();
            }
        }
    },[open])
    
    useEffect(() => {
        if(!closeOpen) {
            if(previousOrder !== null && inputRefWhenOneOrderWasAlreadyScanned.current) {
                //problem is with this one
                inputRefWhenOneOrderWasAlreadyScanned.current.focus();
            } else {
                inputRef.current?.focus();
            }
        }
    },[closeOpen])

    useEffect(() => {
        if(!paModalOpen) {
            if(previousOrder !== null && inputRefWhenOneOrderWasAlreadyScanned.current) {
                //problem is with this one
                inputRefWhenOneOrderWasAlreadyScanned.current.focus();
            } else {
                inputRef.current?.focus();
            }
        }
    },[paModalOpen])

    useEffect(() => {
        if(!outboundInstructionModal.open) {
            if(previousOrder !== null && inputRefWhenOneOrderWasAlreadyScanned.current) {
                inputRefWhenOneOrderWasAlreadyScanned.current.focus();
            } else {
                inputRef.current?.focus();
            }
        }
    },[outboundInstructionModal.open])

    useEffect(() => {
        if(!skipModalOpen){
            if(previousOrder !== null && inputRefWhenOneOrderWasAlreadyScanned.current) {
                //problem is with this one
                inputRefWhenOneOrderWasAlreadyScanned.current.focus();
            } else {
                inputRef.current?.focus();
            }
        }
    },[skipModalOpen])

    useEffect(() => {
        const restoreFocus = (e) => {
            // If the user clicks inside an input, do NOT steal focus
            const isInput =
                e.target instanceof HTMLInputElement ||
                e.target instanceof HTMLTextAreaElement ||
                e.target.isContentEditable;

            const isBox = e.target.closest(".clickable-box");

            if (!isInput && !isBox) {
                setTimeout(() => {
                    if(previousOrder !== null && inputRefWhenOneOrderWasAlreadyScanned.current) {
                        inputRefWhenOneOrderWasAlreadyScanned.current.focus();
                    } else {
                        inputRef.current?.focus();
                    }
                }, 0);
            }
        };

        document.addEventListener("mousedown", restoreFocus);

        return () => {
            document.removeEventListener("mousedown", restoreFocus);
        };
    }, [previousOrder,inputRefWhenOneOrderWasAlreadyScanned]);

    return(
        <Box
            sx={{
                flex:1,
                marginBottom:3,
                position:"relative",
                display:"flex",
                overflow:"hidden",
                "@media screen and (max-width: 1080px)" : {
                    flexDirection:'column'
                }
            }}
        >
            <Box 
                sx={{
                    overflow:"auto",
                    "@media screen and (max-width: 1080px)" : {
                        display:'flex'
                    }
                }}
            >
                <ButtonBase
                    onClick={() => {
                        props.setOrderToFinalize(null);
                        props.setShowEcheck(false);
                    }}
                    sx={{
                        opacity: !isBundling ? 1 : 0.35,
                        ml:"-16px",
                        fontWeight:"bold",
                        p:2,
                        color:theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400]
                    }}
                >
                    {selectedOrder !== null ? t("go_back") : t("close")}
                </ButtonBase>
                {currentOrder !== null &&
                    <Box
                        sx={{
                            opacity: !isBundling ? 1 : 0.35,
                            display:"flex",
                            "@media screen and (max-width: 1080px)" : {
                                flexDirection:'column',
                                justifyContent:"center",
                            }
                        }}
                    >
                        <Box
                            sx={{
                                width:380,
                                background:theme.palette.mode === "dark" ? colors.pink[100] : colors.pink[100],
                                padding:2,
                                // pb:0,
                                borderRadius:4,
                            }}
                        >
                            <Box
                                sx={{
                                    display:"flex",
                                    flexDirection:'column',
                                }}
                            >
                                <Heading 
                                    color={theme.palette.mode === "dark" ? colors.pink[400] : colors.pink[400]} 
                                    sx={{
                                        mb:1
                                    }}
                                >
                                    {t("to_scan_in_order")}
                                </Heading>

                                <Box
                                    sx={{
                                        display:"flex",
                                        height:48,
                                        borderRadius:6,
                                        background:theme.palette.mode === "dark" ? colors.grey[800] : colors.pink[100],
                                        marginTop:0.5,
                                        marginBottom:0.5,
                                        justifyContent:"space-between",
                                        position:'relative',
                                        overflow:"hidden",
                                        mb:1.5,
                                        "@media screen and (max-width: 47.9375em)" : {
                                            flexDirection:"column"
                                        },

                                        "&:before" : {
                                            content:"''",
                                            position:'absolute',
                                            left:0,
                                            width:"40px",
                                            height:"40px",
                                            transform:"translate(-50%, -50%)",
                                            background: `linear-gradient(var(--gradient-angle), #C2D7FF, ${theme.palette.mode === "dark" ? colors.pink[400] : "#D8005B"}, #C2D7FF)`,
                                            borderRadius:3,
                                            animation: "button-highlighter 3s linear infinite",
                                            filter:"blur(12px)",
                                            zIndex: 1, 
                                        },

                                        "&:after" : {
                                            content:"''",
                                            position:'absolute',
                                            top:4,
                                            left:4,
                                            width:"calc(100% - 8px)",
                                            height:"calc(100% - 8px)",
                                            background: theme.palette.mode === "dark" ? colors.grey[400] : "#fff",
                                            border: `1px solid ${colors.grey[200]}`,
                                            borderRadius:"inherit",
                                            zIndex: 2, 
                                        }
                                    }}
                                >
                                    <Box 
                                        sx={{ 
                                            position: "relative", 
                                            zIndex: 3, 
                                            display: "flex", 
                                            alignItems: "center" 
                                        }}
                                    >
                                        <img src="/img/barcode.svg" style={{ width: 24, marginLeft: 16 }} />
                                        <Box sx={{ ml: 2 }}>
                                            <Text light>{t("scan_barcode")}</Text>
                                        </Box>
                                    </Box>

                                </Box>

                                {toScanRows?.map((row, index) => {
                                    return (
                                    
                                        <ToScanProductRow
                                            key={"tspr"+index}
                                            setHighlightColor={props.setHighlightColor}
                                            setChosenProductForSerial={setChosenProductForSerial}
                                            serialNumberData={serialNumberData}
                                            row={row}
                                            index={index}
                                            setMatchedProduct={setMatchedProduct}
                                            hasClickToScanPermission={props.hasClickToScanPermission}
                                            viewStocksInOrderProcessing={props.viewStocksInOrderProcessing}
                                            viewPickingLinesInOrderProcessing={props.viewPickingLinesInOrderProcessing}
                                            clickAllProducts={props.clickAllProducts}
                                        />
                                    )
                                })}

                                {toScanRows?.length === 0 &&
                                    <Box
                                        sx={{
                                            flex:1,
                                            display:"flex",
                                            background:theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[0],
                                            border: theme.palette.mode === "light" ? `1px solid ${colors.grey[100]}` :null,
                                            boxShadow: theme.palette.mode === "light" ? "0 2px 4px rgba(49,65,95,.15)" : null,
                                            borderRadius:3,
                                            padding:1,
                                            alignItems:"center",
                                            justifyContent: "center",
                                            opacity:0.7,
                                        }}
                                    >
                                        <Text semibold sx={{marginLeft: 2,
                                            opacity:0.7,}}>
                                            {t("everything_scanned")}
                                        </Text>
                                    </Box>
                                }
                            </Box>


                        </Box>

                        <Box
                            width={120}
                            sx={{
                                display: "flex",
                                paddingBottom: 3,
                                justifyContent: "center",
                                alignItems: "center",
                                color: colors.grey[300],
                                position: "relative", // For controlling the layout and positioning
                                "@media screen and (max-width: 1080px)": {
                                    transform: "rotate(90deg)",
                                    width: 380,
                                },
                            }}
                        >
                            {/* Wrapper Box for animation */}
                            <Box
                                sx={{
                                    overflow:"hidden",
                                    width: "100%",
                                    // height: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    animation: "moveArrow 1.5s infinite ease-in-out", // Animation applied to wrapper box
                                    "@keyframes moveArrow": {
                                        "0%": {
                                        transform: "translateX(0)", // Start position
                                        },
                                        "50%": {
                                        transform: "translateX(15%)", // Move to the right (adjust as needed)
                                        },
                                        "100%": {
                                        transform: "translateX(0)", // Return to the start
                                        }
                                    },
                                }}
                            >
                                <img
                                    className="supra-arrow"  // Keep the class for potential future use
                                    src="/img/arrow.svg"
                                    alt="Barcode"
                                    style={{
                                        width: "40%",   // Image size
                                        height: "40%",  // Image size
                                        objectFit: "contain", // Ensures the image fits the container
                                    }}
                                />
                            </Box>
                        </Box>
                    </Box>
                }

                <Box
                    sx={{
                        display:"flex",
                        "@media screen and (max-width: 1080px)" : {
                            flexDirection:'column',
                            justifyContent:"center",
                        }
                    }}
                >
                    <Box
                        sx={{
                            width:380,
                            mt:currentOrder !== null ? 4 : 0,
                            borderRadius:4,
                        }}
                    >
                        <Box
                            sx={currentOrder !== null ? {
                                userSelect:"none",
                                display:"flex",
                                gap:1.5,
                                flexDirection:'column',
                                position:'relative',
                            } : {
                                userSelect:"unset",
                                display:"flex",
                                gap:1.5,
                                flexDirection:'column',
                                position:'relative',
                                minHeight:selectedOrder !== null ?  180 : null,
                            }}
                        >

                            <EcheckOrderListHeader
                                resetScreen={resetScreen}
                                incData={props.incData}
                                setHighlightColor={props.setHighlightColor}
                            />

                            {toScanProducts?.length > 0 &&
                                <>
                                    <Subheading
                                        sx={{
                                            opacity: currentOrder !== null || selectedOrder !== null ? 0.35 : 1,
                                        }}
                                    >
                                        {t("to_process")}
                                    </Subheading>
                                    {toScanProducts?.map((row, index) => {
                                        if(row.amountEchecked >= row.amount) return null;
                                        return (
                                            <Box
                                                key={"scan-prod"+index}
                                                className="clickable-box"
                                                onClick={() => {
                                                    const validation = getProductValidation(row.product);

                                                    if(validation === echeck_scan_option.NEVER_SCAN) {
                                                        // never_scan: always allow clicking
                                                    const validation = getProductValidation(row.product);

                                                    if(validation === echeck_scan_option.NEVER_SCAN) {
                                                        // never_scan: always allow clicking
                                                        if(row.type === orderline_type.ADD_ON) {
                                                            handleSelectAddon(row)
                                                        } else {
                                                            clickToProcessRow(row.product);
                                                        }
                                                    } else if(validation === echeck_scan_option.ALWAYS_SCAN) {
                                                        // always_scan: cannot click unless add_on or clickAllProducts overrides
                                                        if(props.clickAllProducts || row.type === orderline_type.ADD_ON) {
                                                            if(row.type === orderline_type.ADD_ON) {
                                                                handleSelectAddon(row)
                                                            } else {
                                                                clickToProcessRow(row.product);
                                                            }
                                                        }else {
                                                            props.setHighlightColor("orange");
                                                            toast.warn(t("please_scan_item"), {
                                                                position: "bottom-left",
                                                                autoClose: 2500,
                                                                hideProgressBar: false,
                                                                closeOnClick: true,
                                                                pauseOnHover: true,
                                                                draggable: true,
                                                                theme: "light",
                                                            });
                                                        }
                                                    } else {
                                                        // null / default: keep current behavior
                                                        if(props.hasClickToScanPermission || props.clickAllProducts) {
                                                            if(row.type === orderline_type.ADD_ON) {
                                                                handleSelectAddon(row)
                                                            } else {
                                                                clickToProcessRow(row.product);
                                                            }
                                                        } else {
                                                            if(row.type === orderline_type.ADD_ON) {
                                                                handleSelectAddon(row)
                                                            }
                                                        }
                                                    }
                                                }}}
                                                sx={{
                                                    opacity: currentOrder !== null || selectedOrder !== null ? 0.35 : 1,
                                                    width:1,
                                                    display:'flex',
                                                    boxShadow:"0px 2px 4px rgba(49,65,95,.15)",
                                                    border:`1px solid ${colors.grey[100]}`,
                                                    p:2,
                                                    borderRadius:4,
                                                    justifyContent:"space-between",
                                                    alignItems:"flex-start",
                                                    gap:2,
                                                    pointerEvents: row.amountEchecked === row.amount ? "none" : null,
                                                    userSelect: row.amountEchecked === row.amount ? "none" : null,
                                                    background: theme.palette.mode === 'dark' ? row.amountEchecked === row.amount ? colors.green[100] : colors.grey[300] :  row.amountEchecked === row.amount ? colors.green[100] : colors.grey[0]
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        opacity:row.amountEchecked === row.amount ? 0.5 : 1,
                                                    }}
                                                >
                                                    <Text bold>{row.product.description}</Text><br/>
                                                    <Text>
                                                        {row.product?.barcode}
                                                    </Text>
                                                </Box>

                                                <Box
                                                    sx={{
                                                        flexShrink:0,
                                                        height:32,
                                                        px:2,
                                                        display:"flex",
                                                        justifyContent:'center',
                                                        alignItems:'center',
                                                        background: row.amountEchecked === row.amount ? colors.green[100] : theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[100],
                                                        fontFamily:"Roboto, sans-serif",
                                                        color: row.amountEchecked === row.amount ? colors.green[400] : colors.txt["primary"],
                                                        borderRadius:4,
                                                        border: `1px solid ${row.amountEchecked === row.amount ? colors.green[400] : "transparent"}`
                                                    }}
                                                >
                                                    {row.amountEchecked} / <b>{row.amount}</b>


                                                </Box>

                                            </Box>
                                        );
                                    })}

                                    {selectedOrder !== null &&
                                    
                                        <Box
                                            sx={{
                                                position:'absolute',
                                                left:0,
                                                top:32,
                                                bottom:0,
                                                width:1,
                                                backdropFilter:"blur(1px)",
                                                background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[50],
                                                border:`1px solid ${colors.grey[200]}`,
                                                borderRadius:4,
                                                display:'flex',
                                                justifyContent:'center',
                                                alignItems:'center',
                                                textAlign:'center',
                                                px:3,
                                                minHeight:120,
                                                // background:"orange"
                                            }}
                                        >
                                            <Text align="center">
                                                Om verder te gaan met verwerken druk dan hierboven op <b>"Ga terug"</b>.
                                            </Text>
                                        </Box>
                                    }
                                </>
                            }
                            
                        </Box>

                        
                        {previousOrder !== null &&
                            <Box
                                sx={{
                                    mt:3,
                                    // display:"flex",
                                    display:"flex",
                                    "@media screen and (max-width: 1080px)" : {
                                        flexDirection:'column',
                                        justifyContent:"center",
                                    }
                                }}
                            >
                                <Box
                                    sx={{
                                        width:380,
                                        background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[50],
                                        padding:2,
                                        borderRadius:4,
                                    }}
                                >

                                    <Box
                                        sx={{
                                            flex: 1,
                                            background: theme.palette.mode === "dark" ? colors.grey[400] : colors.bg["tertiary"],
                                            borderRadius: 4,
                                            // marginTop: 3,
                                            paddingTop:4,
                                            overflow: "hidden",
                                            display: "flex",
                                            flexDirection: "column",
                                            paddingBottom: 3,
                                            justifyContent: 'center',  // To center contents vertically
                                            alignItems: 'center',      // To center contents horizontally
                                        }}
                                    >
                                        <img 
                                            src="/img/barcode.svg" 
                                            alt="Barcode" 
                                            style={{
                                                width: '30%', 
                                                height: '30%', 
                                                objectFit: 'contain',
                                                animation: 'pulsate 1.5s infinite'
                                            }} 
                                        />

                                       <Box
                                            sx={{
                                                display:"flex",
                                                height:48,
                                                borderRadius:6,
                                                background:theme.palette.mode === "dark" ? colors.grey[800] : colors.pink[100],
                                                marginTop:0.5,
                                                marginBottom:0.5,
                                                justifyContent:"space-between",
                                                position:'relative',
                                                overflow:"hidden",
                                                mb:1.5,
                                                "@media screen and (max-width: 47.9375em)" : {
                                                    flexDirection:"column"
                                                },

                                                "&:before" : {
                                                    content:"''",
                                                    position:'absolute',
                                                    left:0,
                                                    width:"40px",
                                                    height:"40px",
                                                    transform:"translate(-50%, -50%)",
                                                    background: `linear-gradient(var(--gradient-angle), #C2D7FF, ${theme.palette.mode === "dark" ? colors.pink[400] : "#D8005B"}, #C2D7FF)`,
                                                    borderRadius:3,
                                                    animation: "button-highlighter 3s linear infinite",
                                                    filter:"blur(12px)",
                                                    zIndex: 1, 
                                                },

                                                "&:after" : {
                                                    content:"''",
                                                    position:'absolute',
                                                    top:4,
                                                    left:4,
                                                    width:"calc(100% - 8px)",
                                                    height:"calc(100% - 8px)",
                                                    background: theme.palette.mode === "dark" ? colors.grey[400] : "#fff",
                                                    border: `1px solid ${colors.grey[200]}`,
                                                    borderRadius:"inherit",
                                                    zIndex: 2, 
                                                }
                                            }}
                                        >
                                            <Box 
                                                sx={{ 
                                                    position: "relative", 
                                                    zIndex: 3, 
                                                    display: "flex", 
                                                    alignItems: "center" 
                                                }}
                                            >
                                                <img src="/img/barcode.svg" style={{ width: 24, marginLeft: 16 }} />
                                                <Box sx={{ ml: 2 }}>
                                                    <Text light>{t("scan_barcode")}</Text>
                                                </Box>
                                            </Box>

                                        </Box>
                                    </Box>

                                </Box>
                            </Box>
                        }
                        

                    </Box>

                    <Box
                        width={120}
                        sx={{
                            opacity:0,
                            visibility:"hidden",
                            display: "flex",
                            // flexDirection: "column",
                            paddingBottom: 3,
                            justifyContent: 'center',  // To center contents vertically
                            alignItems: 'center',
                            color: colors.grey[300],
                          
                            
                        }}
                    >
                        <img
                            className="supra-arrow"
                            src="/img/arrow.svg" 
                            alt="Barcode" 
                            style={{
                               
                            }}
                        />
                    </Box>
                 
                </Box>
            </Box>
            
            <Box
                sx={{
                    background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[100],

                    flex:1,
                    p:2,
                    borderRadius:6,
                    // borderTopLeftRadius:24,
                    // borderTopRightRadius:24,
                    flexDirection: "column",
                    display:"flex",
                }}
            >
                {currentOrder !== null ?
                    <>
                        <InputBase 
                            inputRef={inputRef}
                            sx={{
                                position: "absolute",
                                opacity: 0,
                                pointerEvents: "none",
                                width: 0,
                                height: 0,
                            }} 
                            placeholder={t("scan_type_barcode")}
                            onKeyDown={handleKeyDown}
                            autoFocus={true}
                        />
                        <EcheckView
                            hasAllowedToSetCustomCarrierShipperPermission={props.hasAllowedToSetCustomCarrierShipperPermission}
                            autoFinalize={props.autoFinalize && !isRestartedOrder}
                            carrierMandatory={props.carrierMandatory}
                            setGoFinalize={setGoFinalize}
                            playError={props.playError}
                            playSuccess={props.playSuccess}
                            maxCarrierAmount={maxCarrierAmount}
                            carrierToAddTo={carrierToAddTo}
                            setCarrierToAddTo={setCarrierToAddTo}
                            setHighlightColor={props.setHighlightColor}
                            setToScanRows={setToScanRows}
                            setOriginalOrderlines={setOriginalOrderlines}
                            setSkuSerialMap={setSkuSerialMap}
                            setCarriers={setCarriers}
                            clearInstructionShown={clearInstructionShown}
                            isBundling={isBundling}
                            setIsBundling={setIsBundling}
                            newBundleName={newBundleName}
                            setNewBundleName={setNewBundleName}
                            newBundle={newBundle}
                            setNewBundle={setNewBundle}
                            updateCostProduct={updateCostProduct}
                            invoiceProducts={invoiceProducts}
                            setInvoiceProducts={setInvoiceProducts}
                            invoiceProductsEcheck={props.invoiceProductsEcheck}
                            totalAmount={totalAmount}
                            carriers={carriers}
                            deliveryOptions={deliveryOptions}
                            selectLabel={selectLabel}
                            selectManualCarrier={selectManualCarrier}
                            OwnCarrierClick={OwnCarrierClick}
                            carriersSelect={carriersSelect}
                            toScanRows={toScanRows}
                            showOptions={showOptions}
                            selectedShipper={selectedShipper}
                            selectedShipperProfile={selectedShipperProfile}
                            currentOrder={currentOrder}
                            shippers={shippers}
                            selectShipper={selectShipper}
                            selectShipperProfile={selectShipperProfile}
                            showSlide={showSlide}
                            finalizeLoading={finalizeLoading}
                            finalizingWithoutLabel={finalizingWithoutLabel}
                            finalizeFetching={finalizeFetching}
                            selectedTimeSlotOptions={selectedTimeSlotOptions}
                            selectTimeSlot={selectTimeSlot}
                            selectedTimeSlot={selectedTimeSlot}
                            isPickupReplenishment={isPickupReplenishment}
                            pickupTimeSlotError={pickupTimeSlotError}
                        />
                    </>
                :
                selectedOrder !== null ?
                    <SelectedOrderView
                        selectedOrder={selectedOrder}
                        setSelectedOrder={setSelectedOrder}
                        resetScreen={resetScreen}
                        setHighlightColor={props.setHighlightColor}
                        selectedWorkSpace={props.selectedWorkSpace}
                        onRestartEcheck={restartEcheck}
                    />
                :

                previousOrder !== null ?
                    <>
                        <PreviousOrderEchecked
                            previousOrder={previousOrder}
                            onRestartEcheck={restartEcheck}
                        />

                        <InputBase 
                            inputRef={inputRefWhenOneOrderWasAlreadyScanned}
                            sx={{
                                position: "absolute",
                                opacity: 0,
                                pointerEvents: "none",
                                width: 0,
                                height: 0,
                            }} 
                            placeholder={t("scan_type_barcode")}
                            onKeyDown={handleKeyDown}
                            autoFocus={true}
                        />
                    </>
                :
                    <Box
                        sx={{
                            flex:1,
                            flexDirection: "column",
                            display:"flex",
                            p:2,
                            borderRadius:4,
                            position:'relative',
                            // borderTopLeftRadius:16,
                            // borderTopRightRadius:16,
                            background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[0],

                        }}
                    >

                        <Box
                            sx={{
                                flex: 1,
                                borderRadius: 4,
                                // marginTop: 3,
                                paddingTop:4,
                                overflow: "hidden",
                                display: "flex",
                                flexDirection: "column",
                                paddingBottom: 3,
                                justifyContent: 'center',  // To center contents vertically
                                alignItems: 'center',      // To center contents horizontally
                            }}
                        >

                            <Box
                                sx={{
                                    height:210,
                                    width:440,
                                    borderRadius:5,
                                    position:"relative",
                                    display:"flex",
                                    alignItems:"center",
                                    justifyContent:"center",
                                    background:theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[200],
                                    border:`1px solid ${theme.palette.mode === "dark" ? colors.grey[100] : colors.grey[300]}`,
                                    "& .echeck-barcode-svg" : {
                                        height:150,
                                        width:"380px !important",
                                        animation: 'pulsate 2s infinite',
                                        "& path" : {
                                            fill: theme.palette.mode === "dark" ? colors.txt["secondary"] : "#8E96A7"
                                        }
                                    }
                                }}
                            >
    
                                {!findProductByIdInPickingJobLoading ?
                                    <BarcodeSvg 
                                        className="echeck-barcode-svg"
                                    />
                                :
                                    <CircularProgress className='is-loading-spinner'/>
                                }
                            </Box>
                           
                            <Box
                                sx={{
                                    mt:1.5,
                                    display:"flex",
                                    height:48,
                                    borderRadius:6,
                                    background:theme.palette.mode === "dark" ? colors.grey[800] : colors.grey[200],
                                    marginBottom:0.5,
                                    justifyContent:"space-between",
                                    position:'relative',
                                    overflow:"hidden",
                                    width:440,
                                    "@media screen and (max-width: 47.9375em)" : {
                                        flexDirection:"column"
                                    },

                                    "&:before" : {
                                        content:"''",
                                        position:'absolute',
                                        left:0,
                                        width:"40px",
                                        height:"40px",
                                        transform:"translate(-50%, -50%)",
                                        background: `linear-gradient(var(--gradient-angle), #C2D7FF, ${theme.palette.mode === "dark" ? colors.txt["primary"] : "#31415f"}, #ced7e1)`,
                                        borderRadius:3,
                                        animation: "button-highlighter 3s linear infinite",
                                        filter:"blur(12px)",
                                        zIndex: 1, 
                                    },

                                    "&:after" : {
                                        content:"''",
                                        position:'absolute',
                                        top:4,
                                        left:4,
                                        width:"calc(100% - 8px)",
                                        height:"calc(100% - 8px)",
                                        background: theme.palette.mode === "dark" ? colors.grey[400] : "#fff",
                                        border: `1px solid ${colors.grey[200]}`,
                                        borderRadius:"inherit",
                                        zIndex: 2, 
                                    }
                                }}
                            >
                                <Box 
                                    sx={{ 
                                        position: "relative", 
                                        zIndex: 3, 
                                        display: "flex", 
                                        alignItems: "center" 
                                    }}
                                >
                                    <img src="/img/barcode.svg" style={{ width: 24, marginLeft: 16 }} />
                                    <Box sx={{ ml: 2 }}>
                                        <Text light>{t("scan_barcode")}</Text>
                                    </Box>
                                </Box>

                                <InputBase 
                                    inputRef={inputRef}
                                    sx={{
                                        position: "absolute",
                                        opacity: 0,
                                        pointerEvents: "none",
                                        width: 0,
                                        height: 0,
                                    }} 
                                    placeholder={t("scan_type_barcode")}
                                    onKeyDown={handleKeyDown}
                                    autoFocus={true}
                                />
                            </Box>
                        </Box>

                    </Box>
                }

                {currentOrder !== null &&
                    <Box
                        sx={{
                            mt:3,
                            display:"flex",
                            justifyContent:"space-between",
                            alignItems:"center",
                            position:"relative",
                        }}
                    >
                        {shippingErrors && shippingErrors.length > 0 &&
                            <Box 
                                sx={{
                                    position:"absolute",
                                    right:16,
                                    bottom:80,
                                    minWidth:300,
                                    maxHeight:"40vh",
                                    overflow:"auto",
                                    background:colors.red[100],
                                    borderRadius:3,
                                    p:2,
                                    display:"flex",
                                    flexDirection:"column",
                                    gap:1,
                                    transform:"scale(1.1)",
                                    transformOrigin: "bottom right",
                                    pr:8,
                                    maxWidth:500,
                                }}
                            >
                                {shippingErrors.map((err,idx) => (
                                    <Text key={"se"+idx} bold variant={"red"}>{err}</Text>
                                ))}
                                <ShPayloadToggle payload={shippingPayload} />
                                 <ShCopyButton
                                    styles={{button:{
                                        background:colors.red[100],
                                        color: colors.red[400],
                                        "&:hover" : {
                                            background:colors.red[400],
                                            color: theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt['light'],
                                        }
                                    }}} 
                                    sx={{position:"absolute",top:56,right:16,zIndex:3000}} 
                                    className={"copyel"} 
                                    closeAfter={1500} 
                                    value={shippingErrors.join('\n')}
                                ></ShCopyButton>
                                <IconButton
                                    onClick={() => setShippingErrors([])}
                                    sx={{
                                        position:"absolute",
                                        top:16,
                                        right:16,
                                        zIndex:3000,
                                        background:colors.red[100],
                                        color: colors.red[400],
                                        "&:hover" : {
                                            background:colors.red[400],
                                            color: theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt['light'],
                                        }
                                    }}
                                >
                                    <CloseIcon fontSize="small"/>
                                </IconButton>
                            </Box>
                        }
                        
                        <ButtonGroup
                            version={2}
                        >
                            <Shbutton 
                                className={"group-btn"}  
                                color={theme.palette.mode === "dark" ? "primaryGrey" : "grey"} 
                                variant="contained"
                                onClick={
                                    () => {
                                        // handleSkipOrder()
                                        skipOrderModal.setOpen(true);
                                    }
                                }
                            >
                                {t("skip")}
                            </Shbutton>
                            {props.canFinalizeWithoutLabel && !currentOrder?.bolReplenishmentId &&
                                <Shbutton
                                    className={"group-btn"}
                                    color={"red"}
                                    variant="contained"
                                    isLoading={finalizeLoading || finalizeFetching}
                                    onClick={() => setWithoutLabelModalOpen(true)}
                                >
                                    {t("finalize_without_label")}
                                </Shbutton>
                            }
                        </ButtonGroup>
                        <ButtonGroup version={2}>
                            {/* <Shbutton className={"group-btn"} isLoading={finalizeLoading || finalizeFetching} onClick={() => printPickingSlip()} color={theme.palette.mode === "dark" ? "blue" : "primary"} variant="contained">
                                Print pakbon
                            </Shbutton> */}
                            
                            {/* <Shbutton className={"group-btn"} color={"primaryGrey"} variant="contained" onClick={() => JokerClick()}>Joker</Shbutton> */}
                            <Shbutton 
                                className={"group-btn"} 
                                isLoading={finalizeLoading || finalizeFetching} 
                                color={"green"} variant="contained" 
                                onClick={() => FinalizeClick()}
                            >
                                Afronden
                            </Shbutton>
                        </ButtonGroup>
                    </Box>
                }
            </Box>


            <MEcheckCheckSerialNumber
                onOpen={() => serialNumberData.setOpen(true)} 
                onClose={() => serialNumberData.setOpen(false)} 
                open={serialNumberData.open} 
                handleClose={selectRow}
                skuSerialMap={skuSerialMap}
                chosenProductForSerial={chosenProductForSerial}
            />

            <MConfirmationWithValue
                open={confirmModal.open}
                handleClose={() => confirmModal.setOpen(false)}
                data={confirmModal.data}
                confirm={confirmModal.confirm}
                // barcodeView={barcodeView}
            />


            <MConfirmationWithValue
                open={confirmCloseModal.open}
                handleClose={() => confirmCloseModal.setOpen(false)}
                data={confirmCloseModal.data}
                confirm={confirmCloseModal.confirm}
                // barcodeView={barcodeView}
            />
            <MConfirmationWithValue
                open={productAmountModal.open}
                handleClose={() => {
                    productAmountModal.setOpen(false);
                    setMatchedProduct(null);
                }}
                data={productAmountModal.data}
                confirm={productAmountModal.confirm}
                min={1}
                max={matchedProduct?.amount}
            />
            <MPauseOrder
                open={skipOrderModal.open}
                handleClose={() => skipOrderModal.setOpen(false)}
                data={skipOrderModal.data}
                orderNumber={currentOrder?.barcode}
                confirm={skipOrderModal.confirm}
                onChange={setValueForSkipReason}
            />
            <MPauseOrder
                open={withoutLabelModalOpen}
                handleClose={() => setWithoutLabelModalOpen(false)}
                orderNumber={currentOrder?.barcode}
                title={t("finalize_without_label_title", { barcode: currentOrder?.barcode ?? "" })}
                reasonLabel={t("reason_to_finalize_without_label")}
                hideFollowUp
                reasonRequired
                confirm={(data) => FinalizeClick({ skipReason: data.skipReason })}
            />
            <MSelectLabel
                open={labelsModal.open}
                handleClose={() => setLabelsModal({ open: false, labels: [], type: '' })}
                labels={labelsModal.labels}
                type={labelsModal.type}
            />
            <MHasDocumentsModal
                open={hasDocumentsModel.open}
                handleClose={() => setDocumentsModal({ open: false})}
            />

            <MConfirmation
                open={finalizeMessageModal.open}
                ignoreCloseAfterConfirm
                handleClose={() => {
                    setFinalizeMessageModal({ open: false, message: "" });
                    resetScreen();
                }}
                confirm={() => {
                    setFinalizeMessageModal({ open: false, message: "" });
                    resetScreen();
                }}
                forceNoContent={false}
                title={t("echeck_finalize_message_title")}
                content={finalizeMessageModal.message}
            />

            <MConfirmation
                open={productAmountModalOpen}
                handleClose={() => { setProductAmountModalOpen(false); setPendingWithoutLabel(null); }}
                confirm={() => finalize(true, pendingWithoutLabel)}
                title={t("amount_of_products")}
                content={
                    <Trans
                        i18nKey="echeck_confirm_product_amount_text"
                        values={{ amount: currentOrder?.amountOfProducts }}
                        components={{ amount: <Box component="span" sx={{ fontWeight: 700, fontSize: 20 }} /> }}
                    />
                }
            />

            <MConfirmation
                open={orderValueModal.open}
                hideCancel
                ignoreCloseAfterConfirm
                handleClose={acknowledgeOrderValue}
                confirm={acknowledgeOrderValue}
                confirmLabel={t("close")}
                title={t("echeck_finalize_message_title")}
                content={
                    <Trans
                        i18nKey="echeck_order_value_exceeds_text"
                        values={{ threshold: formatPrice(i18n, currentOrder?.relation?.echeckOrderValueThreshold ?? 0) }}
                        components={{ amount: <Box component="span" sx={{ fontWeight: 700, fontSize: 20 }} /> }}
                    />
                }
            />

            <MEcheckOutboundInstruction
                open={outboundInstructionModal.open}
                handleClose={() => setOutboundInstructionModal(prev => ({ ...prev, open: false }))}
                sku={outboundInstructionModal.sku}
                instruction={outboundInstructionModal.instruction}
            />

        </Box>
    )
}

export default IndividualOrderEcheckView;
